import { render, staticRenderFns } from "./taskFileModal.vue?vue&type=template&id=20a23bf0&scoped=true"
import script from "./taskFileModal.vue?vue&type=script&lang=js"
export * from "./taskFileModal.vue?vue&type=script&lang=js"
import style0 from "./taskFileModal.vue?vue&type=style&index=0&id=20a23bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a23bf0",
  null
  
)

export default component.exports